import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import orderConfig from "emun.order/order.config";

export default class OrderTotalsPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.config = cartConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.order = Object.assign({}, options.model, options.order);
    $ctrl.title = options.title || "Order Totals";
    $ctrl.groupings = orderConfig.groupings || [
      {
        id: "vendorLabel",
        label: $ctrl.$labels.Vendor || "Vendor"
      },
      {
        id: "cartItemShipOn",
        label: "Ship Date"
      }
    ];
  }
  splitOrder() {
    const $ctrl = this;
    $ctrl.$close($ctrl.order);
    var grouping = $ctrl.groupings.filter(function (obj) {
      return obj.id == $ctrl.totalsQuery.criteria.groupBy;
    });
    //console.info('grouping', grouping[0]);
    $ctrl.$cart.split($ctrl.order.id, grouping[0].id, $ctrl.selected);
    //return modals.confirm("Are you sure?", "Split Order").result.then(function () {
    //	let busy = modals.busy('Splitting order...', `Thank you for your patience as order ${$ctrl.order.id} is split.`);
    //	$ctrl.bus.send('SplitOrder.json', {
    //		orderNumber: $ctrl.order.id,
    //		splitBy: grouping[0].label
    //	}).then(function (response) {
    //		$ctrl.$emit('orderSplit', $ctrl);
    //		$ctrl.$cart.reset();
    //		$ctrl.$state.transitionTo('orders');
    //		busy.close();
    //	}, busy.close());
    //});
  }
  $doLoad(key) {
    const $ctrl = this;
    $ctrl.totalsQuery.criteria.groupBy = key;
    $ctrl.totalsQuery.criteria.orderBy = key;
    $ctrl.selectedGrouping = $ctrl.groupings.filter(g => g.id == key)[0];
    $ctrl.totalsQuery.load(true);
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.selected = [];
    $ctrl.selectedGrouping = $ctrl.groupings[0];
    $ctrl.key = $ctrl.selectedGrouping.id;
    $ctrl.label = $ctrl.selectedGrouping.label;
    $ctrl.totalsQuery = new AutoQuery({
      //			url: 'QueryCartItemsJoin.json?cartId=' + $ctrl.order.id + '&Sum=extendedTotal&Count=productId&groupBy=' + $ctrl.selectedGrouping.id,
      url: "QueryCartItemsJoin.json?OrderTotalsGroupBy=true&Active=true",
      criteria: {
        cartId: $ctrl.order.id,
        Sum: "extendedTotal",
        Count: "productId",
        groupBy: $ctrl.selectedGrouping.id,
        orderBy: $ctrl.selectedGrouping.id
      },
      onLoaded: function(args) {
        args.results.map(r => r.selected = false);
      },
      autoLoad: true,
      pageSize: 100
    });
  }
  setKeys() {
    const $ctrl = this;
    $ctrl.selected = [];
    $ctrl.totalsQuery.results.filter((l) => l.selected).map(s => {
      if ($ctrl.totalsQuery.criteria.groupBy == "vendorLabel") $ctrl.selected.push(s.vendorLabel);
      if ($ctrl.totalsQuery.criteria.groupBy == "cartItemShipOn") $ctrl.selected.push(moment.utc(s.cartItemShipOn).format("MM/DD/YYYY"));
      if ($ctrl.totalsQuery.criteria.groupBy == "ProductAvailableOn") $ctrl.selected.push(moment.utc(s.productAvailableOn).format("MM/DD/YYYY"));
      if ($ctrl.totalsQuery.criteria.groupBy == "CartItemCategory") $ctrl.selected.push(s.cartItemCategory);
      if ($ctrl.totalsQuery.criteria.groupBy == "CartItemSubCategory") $ctrl.selected.push(s.cartItemSubCategory);
      if ($ctrl.totalsQuery.criteria.groupBy == "ProductItemType") $ctrl.selected.push(total.productItemType == 'Kit' ? 'Prepack' : total.productItemType);
    });
  }
}
